import { produce } from 'immer';
import { createSelector } from 'reselect';
import { uniqBy } from 'lodash-es';
import { ScopedType } from './scoped-type';
import { actions as fieldActions } from './fields-dux';
import { actions as alertActions } from './alerts-dux';
import { actions as permissionActions } from './permissions-dux';

const SLICE = 'growerOperations';
const Type = ScopedType('GROWER');
const SELECT = Type('SELECT');
const SELECT_ORGANIZATION = Type('SELECT_ORGANIZATION');

export const selectors = {
  all: createSelector(
    (state) => state.auth?.growers,
    (state) => state[SLICE]?.selectedOrganization,
    (growers, selectedOrganization) =>
      selectedOrganization?.id
        ? growers.filter(
            (grower) => grower.organizationId === selectedOrganization.id,
          )
        : growers,
  ),
  selected: (state) => state[SLICE]?.selectedGrowerOperation,
  selectedId: (state) => state[SLICE]?.selectedGrowerOperation?.guid,
  selectedName: (state) => state[SLICE]?.selectedGrowerOperation?.operationName,
  selectedOrganization: (state) => state[SLICE]?.selectedOrganization,
  organizations: createSelector(
    (state) => state.auth?.growers,
    (state) => state.auth?.organizations,
    (growers, organizations) =>
      organizations ||
      uniqBy(
        growers?.map((grower) => grower.organization),
        'id',
      ),
  ),
};

export const actions = {
  setSelectedGrowerOperation(grower) {
    return async (dispatch) => {
      dispatch(permissionActions.refreshPermissions(grower.guid));
      dispatch(alertActions.refreshBanner(grower.guid));
      dispatch({ type: SELECT, payload: grower });
      dispatch(fieldActions.loadGrowerFields(grower.guid));
    };
  },
  resetSelectedGrowerOperation() {
    return async (dispatch) => {
      dispatch(permissionActions.refreshPermissions(null));
      dispatch({ type: SELECT, payload: null });
    };
  },
  setSelectedOrganization(organization) {
    return { type: SELECT_ORGANIZATION, payload: organization };
  },
};

const reducerHandlers = {
  [SELECT]: reduceSelect,
  [SELECT_ORGANIZATION]: reduceSelectOrganization,
};

function reduceSelect(state, payload) {
  state.selectedGrowerOperation = payload;
}

function reduceSelectOrganization(state, payload) {
  state.selectedOrganization = payload;
}

export const reducers = {
  [SLICE]: (
    state = { selectedGrowerOperation: null },
    { type, payload } = {},
  ) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
